import React from 'react';
import Button from '../components/Button';
import closeIcon from '../icons/clear.svg';
import listPostsIcon from '../icons/listPosts.svg';
import styles from './TemplateMobileHeader.module.scss';

interface TemplateMobileHeaderProps {
  openSidebar: () => void;
  onClose?: () => void;
}

const TemplateMobileHeader = ({
  openSidebar,
  onClose,
}: TemplateMobileHeaderProps) => {
  return (
    <div className={styles.container}>
      <Button
        icon={listPostsIcon}
        onClick={openSidebar}
        aria-label="Open Sidebar"
      />
      <div className={styles.title}>Templates</div>
      <Button icon={closeIcon} onClick={onClose} aria-label="Close" />
    </div>
  );
};

export default TemplateMobileHeader;
